import { DimensionsDTO } from "@/lib/shared-types";
import { t } from "i18next";
import { ComputeFieldComponent } from "../../computeFields";

function validDimField(field: unknown) {
  return (
    field != undefined &&
    !(Number(field) <= 0) &&
    field !== "undefined" &&
    field !== "0" &&
    field != "" &&
    field != "false" &&
    field != false
  );
}
export const DimensionsFormatting: ComputeFieldComponent<
  DimensionsDTO & { unknownDimensions?: boolean }
> = ({ input: { unknownDimensions = false, ...input }, lineBreak = false }) => {
  if (!input || unknownDimensions === true)
    return <>{t("computeField.dimensionsUnknown")}</>;

  if (
    !validDimField(input.cm_width) &&
    !validDimField(input.cm_height) &&
    !validDimField(input.cm_depth) &&
    !validDimField(input.cm_diameter)
  )
    return (
      <>
        {t("computeField.dimensionsUnknown")}
        {lineBreak && <br />}
      </>
    );

  const cmDimensions = [
    input.cm_height,
    input.cm_width,
    input.cm_depth,
    validDimField(input.cm_diameter) ? `ø ${input.cm_diameter}` : undefined,
  ]
    .filter(validDimField)
    .join(" x ");

  const inDimensions = [
    input.in_height,
    input.in_width,
    input.in_depth,
    validDimField(input.in_diameter) ? `ø ${input.in_diameter}` : undefined,
  ]
    .filter(validDimField)
    .join(" x ");

  return (
    <>
      {cmDimensions} cm - {inDimensions} in.
      {lineBreak && <br />}
    </>
  );
};
